module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp13_8003.5e8b9450.png";